module.exports = __webpack_public_path__ + "img/about-辅导项目-大型医用设备类.71d7785b.jpg";